/**
 * Stars reward efficiency: the total weight of the masses used against the level's par.
 *   3 stars: weight <= par
 *   2 stars: weight <= par + 2
 *   1 star : any other win
 * Each hint taken on the level costs one star (never below one).
 */
export function starsFor(weight: number, par: number, hints = 0): 1 | 2 | 3 {
  const base = weight <= par ? 3 : weight <= par + 2 ? 2 : 1;
  return Math.max(1, base - Math.max(0, hints)) as 1 | 2 | 3;
}

/** Best stars still reachable after `hints` hints. */
export function starCap(hints: number): number {
  return Math.max(1, 3 - Math.max(0, hints));
}
